import React, { FC } from 'react';
import classNames from 'classnames';

import { Button, ButtonIntent, ButtonSize } from 'app/design-system/components/Button';

import styles from './ConflictComponent.module.scss';

// ---

type ConflictComponentProps = {
  label: string | JSX.Element;
  buttonText: string;
  onClick: () => void;
  'data-test'?: string;
};

const ConflictComponent: FC<ConflictComponentProps> = ({
  label,
  buttonText,
  onClick,
  ...props
}) => {
  return (
    <div className={styles.text}
         data-test={classNames(props['data-test'], 'conflictComponent-container')}>
      {label}
      <Button intent={ButtonIntent.PRIMARY}
              size={ButtonSize.SMALL}
              className={styles.button}
              data-test="conflictComponent-button"
              onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  );
};

export default ConflictComponent;
